import { tvpil } from '../../compat/tvpil';
import { prefetchFavoriteChannels } from '../../favorite';
import { prefetchLastWatched } from '../../lastWatched';
import { prefetchMostWatched } from '../../mostWatched';
import { prefetchPersonalLineup } from '../../personalLineup';

export function prefetchChannelsPersonalization() {
  if (!tvpil.userId) {
    return Promise.resolve();
  }

  const isPersonalLineupEnabled = tvpil.rootStore.isPersonalLineupEnabled;
  const isFavoriteChannelPersonalization = tvpil.rootStore.isFavoriteChannelPersonalization;

  if (isPersonalLineupEnabled) {
    return Promise.all([prefetchLastWatched(), prefetchPersonalLineup()]);
  }

  if (isFavoriteChannelPersonalization) {
    return Promise.all([
      prefetchLastWatched(),
      prefetchMostWatched({ userId: tvpil.userId }),
      prefetchFavoriteChannels(),
    ]);
  }

  return prefetchLastWatched();
}
